import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['postcode', 'prefecture', 'city'];
  static values = { url: String };

  async search(event) {
    event.preventDefault();

    const postcode = this.postcodeTarget.value.trim();
    if (!postcode) return;

    const url = `${this.urlValue}?postcode=${encodeURIComponent(postcode)}`;

    let data;
    try {
      const res = await fetch(url, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!res.ok) return;
      data = await res.json();
    } catch {
      return;
    }
    if (!data) return;

    if (this.hasPrefectureTarget) {
      const option = Array.from(this.prefectureTarget.options).find(
        (el) => el.text === data.address1,
      );
      if (option) this.prefectureTarget.value = option.value;
    }

    if (this.hasCityTarget) {
      this.cityTarget.value = `${data.address2 || ''}${data.address3 || ''}`;
    }
  }
}
